import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { AdsExpensesLayoutComponent } from './layouts/ads-expenses-layout/ads-expenses-layout.component';
import { AdsExpensesDatatableComponent } from './components/ads-expenses-datatable/ads-expenses-datatable.component';

const DECLARATIONS = [
  AdsExpensesLayoutComponent,
  AdsExpensesDatatableComponent
];

const MODULES = [SharedModule];

// const IMPORT_ONLY_MODULES = [NgxsModule.forFeature([])];

@NgModule({
  declarations: DECLARATIONS,
  // imports: [...MODULES, ...IMPORT_ONLY_MODULES],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class AdsExpensesModule {}
